module.exports = __webpack_public_path__ + "img/TSN_04.eff4f66f.png";